import { FlashList } from "@shopify/flash-list";
import { useCallback, useState } from "react";
import { View } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import CollectDataField from "src/api/graphql/__generated__/enums/CollectDataField";
import ListFooterComponent from "src/components/ListFooterComponent";
import Search from "src/components/Search";
import Touchable from "src/components/Touchable";
import native from "src/constants/native";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useGatheringAndUsers, { UseGatheringAndUsers_User } from "src/hooks/useGatheringAndUsers";
import IconClose from "src/icons/IconClose";
import { useInsideModal } from "src/modals";
import { paddingLarge, paddingXXL } from "src/styles/spacing";
import { List, ListRenderItemInfo, useSafeArea } from "src/swsh-native";
import { GatheringViewerRowHeight } from "../constants";
import GatheringViewerRow from "./GatheringViewerRow";
import GatheringViewersFilterSection from "./GatheringViewersFilterSection";
import ViewersHeader from "./ViewersHeader";

const GatheringViewersList = ({ gatheringId }: { gatheringId: string }) => {
	const [search, setSearch] = useState("");
	const { fetchMore, gathering, refresh, refreshing, loading } = useGatheringAndUsers(
		gatheringId,
		{ search },
	);

	const safeArea = useSafeArea();

	const collectData = useGatheringStore((state) => state.collectData);
	const renderItem = useCallback(
		({ item }: ListRenderItemInfo<UseGatheringAndUsers_User>) => {
			return (
				<GatheringViewerRow
					user={item}
					access={gathering?.access}
					gatheringId={gatheringId}
					onAction={refresh}
					displayContent={collectData ?? [CollectDataField.Instagram, "Snapchat"]}
				/>
			);
		},
		[collectData, gathering?.access, gatheringId, refresh],
	);
	const { closeSelf } = useInsideModal();

	return (
		<View
			style={{
				flex: 1,
			}}
		>
			<View
				style={{
					flexDirection: "row",
					alignItems: "center",
				}}
			>
				{!native && (
					<Touchable
						onPress={closeSelf}
						containerStyle={{
							marginLeft: paddingLarge,
						}}
					>
						<IconClose size={20} />
					</Touchable>
				)}
				<View
					style={{
						flex: 1,
						height: 56,
						alignItems: "center",
					}}
				>
					<Search
						onDebouncedChangeText={setSearch}
						placeholder={{
							text: "Search viewers",
							Icon: null,
						}}
					/>
				</View>
			</View>
			<GatheringViewersFilterSection />
			<ViewersHeader />
			<List
				WebListComponent={FlashList}
				renderScrollComponent={ScrollView}
				estimatedItemSize={GatheringViewerRowHeight}
				data={gathering?.users?.payload}
				renderItem={renderItem}
				keyExtractor={(item) => item.userId}
				onEndReachedThreshold={0.5}
				onEndReached={fetchMore}
				refreshing={refreshing}
				onRefresh={refresh}
				contentInset={{
					bottom: safeArea.bottom + paddingXXL,
				}}
				ListFooterComponent={<ListFooterComponent loading={loading} />}
			/>
		</View>
	);
};
export default GatheringViewersList;
